/**
 * 事件数据
 */
export class EventData {
	/**事件名称 */
	name: string;
	/**整数数据 */
	intValue: number;
	/**单精度浮点数数据 */
	floatValue: number;
	/**字符串数据 */
	stringValue: string;
	/**多媒体数据 */
	audioValue: string;
	/**事件数据 */
	time: number;

	constructor() {

	}

}


